import React from "react";


function CommunityIcon(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" { ...props }>
      <path d="M4 7C4 4.79086 5.79086 3 8 3C10.2091 3 12 4.79086 12 7C12 9.20914 10.2091 11 8 11C5.79086 11 4 9.20914 4 7Z" fill="white"/>
      <path d="M2 18C2 14.6863 4.68629 12 8 12C11.3137 12 14 14.6863 14 18V20C14 20.5523 13.5523 21 13 21H3C2.44772 21 2 20.5523 2 20V18Z" fill="white"/>
      <path d="M16 6C14.3431 6 13 7.34315 13 9C13 10.6569 14.3431 12 16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6Z" fill="white"/>
      <path d="M16 13C15.0835 13 14.218 13.2169 13.4454 13.601C14.4177 14.8031 15.0001 16.3335 15.0001 18V20C15.0001 20.3643 14.9027 20.7058 14.7325 21H21C21.5523 21 22 20.5523 22 20V19C22 15.4781 19.2893 13 16 13Z" fill="white"/>
    </svg>
  );
}

export default CommunityIcon;
